<template>
  <div class="container">
    <AwardsList @reportEvent="handleReportEvent" />
  </div>
</template>

<script>
import rootStore from '@/store';
import store from '../components/myAwards/store';
import AwardsList from '../components/myAwards/AwardsList.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
  components: { AwardsList },
  props: {
    actCode: {
      type: String,
      require: true
    }
  },
  methods: {
    ...mapActions('app/myAwards', ['getAwardsList']),
    ...mapMutations('app/myAwards', ['setActCode']),
    handleReportEvent(data) {
      this.$emit('reportEvent', data);
    }
  },
  beforeDestroy() {
    rootStore.unregisterModule(['app', 'myAwards'], store);
  },
  async created() {
    rootStore.registerModule(['app', 'myAwards'], store);
    await this.setActCode(this.actCode);
    await this.getAwardsList();
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: #f3f4f5;
}
.tabBar {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: space-between;

  &:before,
  &:after {
    content: '';
    display: block;
  }

  .tabItem {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: normal;
    font-size: 30px;
    color: #000;

    &.active {
      color: #ff6600;
      border-bottom: 4px solid #ff6600;
    }
  }
}

.tabContainer {
  width: 100%;
  height: calc(100vh - 80px);
  overflow-y: auto;
}
</style>
